/** Self-contained neutral profile avatar (always renders, no network needed). */
export const GENERIC_PROFILE_AVATAR_SRC =
  'data:image/svg+xml;utf8,' +
  encodeURIComponent(
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200">' +
      '<rect width="200" height="200" fill="#e8eef8"/>' +
      '<circle cx="100" cy="80" r="34" fill="#b9c8e0"/>' +
      '<path d="M38 170c0-34 28-58 62-58s62 24 62 58z" fill="#b9c8e0"/>' +
      '</svg>',
  );

/** Stock portraits for the home social strip (Unsplash — free to use). */
export const HOME_SOCIAL_STRIP_IMAGES = [
  {
    src: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?auto=format&fit=crop&w=200&h=200&q=80',
    label: 'Liat Nails',
  },
  {
    src: 'https://images.unsplash.com/photo-1560250097-0b93528c311a?auto=format&fit=crop&w=200&h=200&q=80',
    label: 'Avi Design',
  },
  {
    src: GENERIC_PROFILE_AVATAR_SRC,
    label: 'DMarketing',
  },
  {
    src: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?auto=format&fit=crop&w=200&h=200&q=80',
    label: 'Lior H.',
  },
  {
    src: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?auto=format&fit=crop&w=200&h=200&q=80',
    label: 'Maya Studio',
  },
  {
    src: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=200&h=200&q=80',
    label: 'Office Pro',
  },
  {
    src: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?auto=format&fit=crop&w=200&h=200&q=80',
    label: 'Space Co',
  },
  {
    src: 'https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?auto=format&fit=crop&w=200&h=200&q=80',
    label: 'Work Hub',
  },
  {
    src: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&w=200&h=200&q=80',
    label: 'Creative Co',
  },
  {
    src: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&w=200&h=200&q=80',
    label: 'Flex Space',
  },
] as const;

export function assetTypeIconKind(label: string): 'all' | 'parking' | 'meeting' | 'open' | 'office' | 'generic' {
  const t = label.trim().toLowerCase();
  if (!t || t === 'all' || t.includes('all type')) {
    return 'all';
  }
  if (t.includes('parking') || t.includes('חני')) {
    return 'parking';
  }
  if (t.includes('meeting') || t.includes('ישיב')) {
    return 'meeting';
  }
  if (t.includes('training') || t.includes('הדרכ')) {
    return 'generic';
  }
  if (t.includes('workshop') || t.includes('סדנ')) {
    return 'generic';
  }
  if (t.includes('open')) {
    return 'open';
  }
  if (t.includes('office') || t.includes('משרד')) {
    return 'office';
  }
  return 'generic';
}
